// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
/** @jsx jsxPragma */

import { jsxPragma } from "@outschool/ui-legacy-component-library";
import { CardCvcElement } from "@stripe/react-stripe-js";
// @ts-ignore TS(6059): File '/Users/jess/src/Outschool/lang-js/node_modul... Remove this comment to see the full error message
import { CardCvcElementProps } from "@stripe/react-stripe-js/src/types";
import { SystemStyleObject } from "@styled-system/css";
import _ from "lodash";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";

import { CARD_ELEMENT_OPTIONS, VARIANT_DEFAULT_SX, Variants } from ".";

interface StripeCardCvcProps extends CardCvcElementProps {
  variant?: Variants;
  sx?: SystemStyleObject;
}

export default function StripeCardCvc({
  variant = Variants.valid,
  sx = {},
  options,
  ...props
}: StripeCardCvcProps) {
  return (
    <CardCvcElement
      options={_.merge(CARD_ELEMENT_OPTIONS, options)}
      // @ts-ignore
      sx={_.merge(VARIANT_DEFAULT_SX[variant], sx)}
      {...props}
    />
  );
}
